import store from '@/store'
import { getUrlOverride, hasUrlOverride } from '../store/modules/url-overrides'
import { getRouteOverride, getRouteForAlias } from '../utils/override-route'

export const requiresError = async (to, from, next) => {
  if (store && store.state && store.state.error && store.state.error.error) {
    next()
  } else {
    next({ path: '/' })
  }
}

export const checkOverridden = async (to, from, next) => {
  const removedPagesPath = to.path.replace('/pages', '')
  const routeOverride = getRouteOverride()
  const aliasOverride = getRouteForAlias()
  if (routeOverride) {
    location.replace(routeOverride)
  } else if (aliasOverride) {
    location.replace(aliasOverride)
  } else if (hasUrlOverride(to.path)) {
    next({ path: getUrlOverride(to.path) })
  }

  if (to.path !== removedPagesPath) {
    next({ path: removedPagesPath })
  }
  next()
}
